import { DownOutlined } from '@ant-design/icons';
import { PRODUCT_ITEMS } from './Links.ts';

export const Items = [
  {
    key: 'products',
    url: '#',
    label: 'Products',
    children: PRODUCT_ITEMS,
  },
  // {
  //   key: 'solutions',
  //   url: '/solutions',
  //   label: 'Solutions',
  //   children: [
  //     {
  //       key: 'nonCustodial',
  //       url: '/nonCustodial',
  //       label: 'Non-Custodial Utility',
  //     }, {
  //       key: 'custodial',
  //       url: '/custodial',
  //       label: 'Compliant Custodial Utility',
  //     }
  //   ]
  // },
  // {
  //   key: 'UseCases',
  //   url: '#',
  //   label: 'Clients',
  //   children: [
  //     {
  //       key: 'digitalAssets',
  //       url: '/digitalAssets',
  //       label: 'Institutional Digital Assets',
  //     },
  //     {
  //       key: 'privateCredit',
  //       url: '/privateCredit',
  //       label: 'Onchain Private Credit',
  //     },
  //     {
  //       key: 'tokenizedRWA',
  //       url: '/tokenizedRWA',
  //       label: 'Tokenized RWA',
  //     },
  //   ]
  // },
  {
    key: 'blog',
    url: '/blog',
    label: 'Blogs'
  },
  // {
  //   key: 'ecosystem',
  //   url: '/ecosystem',
  //   label: 'Partners'
  // },
  // {
  //   key: 'resources',
  //   url: '/blog',
  //   label: 'Resources',
  //   children: [
  //     {
  //       key: 'blog',
  //       url: '/blog',
  //       label: 'Blogs'
  //     },
  //     // {
  //     //   key: 'blog',
  //     //   url: 'https://docs.vishwanetwork.xyz/',
  //     //   label: 'Doc'
  //     // },
  //     {
  //       key: 'podcast',
  //       url: '/podcast',
  //       label: 'Podcast'
  //     }
  //   ]
  // },
  // {
  //   key: 'https://form.typeform.com/to/IjCOn4nY',
  //   url: 'https://form.typeform.com/to/IjCOn4nY',
  //   label: 'Get In Touch',
  // }
]
export const goto = (e) => {
  if (e.key?.startsWith('http')) window.open(e.key, '_blank')
  else if (e.key?.startsWith('/')) window.open(process.env.PUBLIC_URL + e.key, '_self')
}